import {
  Component,
  OnInit,
  OnDestroy,
  AfterContentInit,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import * as Highcharts from "highcharts/highstock";
import HC_exporting from "highcharts/modules/exporting";

import { MatPaginator, PageEvent } from "@angular/material/paginator";

import { ReportsService } from "../../services/reports.service";
import { DashboardService } from "../../services/dashboard.service";
import { CalaDetailModel } from "../../shared/dashboradData.model";

declare var require: any;
let Boost = require("highcharts/modules/boost");
let noData = require("highcharts/modules/no-data-to-display");
let More = require("highcharts/highcharts-more");

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);

@Component({
  selector: "app-commissioner-dashboard",
  templateUrl: "./commissioner-dashboard.component.html",
  styleUrls: ["./commissioner-dashboard.component.scss"],
})
export class CommissionerDashboardComponent
  implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  displayedColumns: string[] = [
    "District Collector",
    "Total land to be aquired",
    "Start Date",
    "3a status",
    "JMS request status",
    "JMS",
    "3A",
    "3C",
    "3D",
    "3G",
    "3H",
    "3H funds distributed",
    "Possession",
    "Mutation",
    "Govt. Land To Be Aquired",
    "Govt. Land Possession",
    "Govt. Land Mutation",
    "Private Land To Be acquired",
    "Total Private Land acquired",
    "Total Private fund disbursed",
    "Funds Diposition Under PN",
    "Funds Distribution Under PN",
  ];

  // Replaced MatTableDataSource with plain arrays (no mat-table)
  allRows: any[] = [];
  filteredRows: any[] = [];
  pagedRows: any[] = [];

  // filter/sort/page state
  filterValue: string = "";
  pageSize: number = 5;
  pageIndex: number = 0;
  totalRows: number = 0;

  sortColumn: string = "";
  sortDirection: "asc" | "desc" = "asc";

  isDownloading: boolean = false;
  isDownloaded: boolean = false;

  id: string = "128";
  projectName: string = "";
  toBeCompleted: any;
  completedTillNow: any;
  projectsList: any;
  inPercentage: any;
  overviewData: any;
  graphData: object;
  array: any[] = [];

  day: number = 5;
  colors = ["#FD6452", "#8FCF52"];
  chart: Highcharts.Chart;
  private resizeObserver: ResizeObserver;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private dashboardService: DashboardService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.id = params.get("id");
      this.projectName = params.get("name");
    });

    this.dashboardService.getCommissionerDashboardData(this.id).subscribe((res) => {
      this.projectName = res.name;
      this.overviewData = res.overview;
      this.toBeCompleted = res.overview.to_be_completed;
      this.completedTillNow = res.overview.total_completed_till_now;
      this.inPercentage = res.percentage;
      this.projectsList = res.details;

      this.array = res.details || [];
      this.array.sort(function (a, b) {
        if ((a.name || "").toLowerCase() < (b.name || "").toLowerCase()) return -1;
        if ((a.name || "").toLowerCase() > (b.name || "").toLowerCase()) return 1;
        return 0;
      });

      // custom table dataset
      this.allRows = [...this.array];
      this.applyFilterSortPaginate();

      //////////////////// High Charts //////////////////////////
      const options: any = {
        chart: { type: "bar" },
        title: {
          text: "Total land aquisition in hactare",
          style: { font: "14px Montserrat,sans-serif;", fontWeight: 600 },
        },
        subtitle: { text: "" },
        accessibility: { announceNewData: { enabled: true } },
        xAxis: {
          type: "category",
          labels: { style: { font: "14px Montserrat,sans-serif;", fontWeight: 600 } },
        },
        yAxis: {
          title: {
            text: "In hactares",
            labels: { style: { font: "14px Montserrat,sans-serif;", fontWeight: 600 } },
          },
        },
        legend: { enabled: false },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
                formatter: function () {
                  const y = this.y;
                  const total = res.overview.total_land_aquire;
                  const pct = total ? (y / total) * 100 : 0;
                  return `${pct.toFixed(2)}%`;
              },
            },
          },
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: `<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b> of <b>${res.overview.total_land_aquire}</b><br/>`,
        },
        series: [
          {
            name: "Aquisition Step",
            colorByPoint: true,
            data: [
              { name: "JMS", y: res.overview.total_completed_till_now.jms },
              { name: "3(A)", y: res.overview.total_completed_till_now["3A"] },
              { name: "3(C)", y: res.overview.total_completed_till_now["3C"] },
              { name: "3(D)", y: res.overview.total_completed_till_now["3D"] },
              { name: "3(G)", y: res.overview.total_completed_till_now["3G"] },
              { name: "3(H)", y: res.overview.total_completed_till_now["3H_area"] },
              { name: "Possession", y: res.overview.total_completed_till_now.possession },
              { name: "Mutation", y: res.overview.total_completed_till_now.mutation },
              { name: "Govt. Land Possession", y: res.overview.total_completed_till_now.govt_possession },
              { name: "Govt. Land Mutation", y: res.overview.total_completed_till_now.govt_mutation },
            ],
          },
        ],
      };

      HC_exporting(Highcharts);
      this.chart = Highcharts.chart("container", options);

      setTimeout(() => {
        if (this.chart) {
          this.chart.reflow();
        }
      }, 0);
    });
  }

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.chart) {
        this.chart.reflow();
      }
    });

    setTimeout(() => {
      const resizeTarget = document.querySelector(".chart-resize-target");
      if (resizeTarget) {
        this.resizeObserver.observe(resizeTarget);
      }
    }, 0);
  }
  ngAfterContentInit() { }

  public doFilter = (value: string) => {
    this.filterValue = (value || "").toLowerCase();
    this.pageIndex = 0;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.firstPage();
    }

    this.applyFilterSortPaginate();
  };

  // paginator event
  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.applyFilterSortPaginate();
  }

  // click header to sort
  toggleSort(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    this.pageIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.firstPage();
    }

    this.applyFilterSortPaginate();
  }

  private applyFilterSortPaginate() {
    let rows = [...(this.allRows || [])];

    // filter
    if (this.filterValue) {
      rows = rows.filter((r) => {
        const blob = [
          r?.name,
          r?.id,
          r?.start_date,
          r?.["3a_status"],
          r?.jms_request_status,
          r?.land_aquire,
          r?.jms,
          r?.["3A"],
          r?.["3C"],
          r?.["3D"],
          r?.["3G"],
          r?.["3H_area"],
          r?.["3H_money"],
          r?.possession,
          r?.mutation,
        ]
          .map((v) => (v ?? "").toString().toLowerCase())
          .join(" ");

        return blob.includes(this.filterValue);
      });
    }

    // sort
    if (this.sortColumn) {
      const dir = this.sortDirection === "asc" ? 1 : -1;
      rows.sort((a, b) => {
        const av = this.getSortValue(a, this.sortColumn);
        const bv = this.getSortValue(b, this.sortColumn);

        if (typeof av === "number" && typeof bv === "number") return (av - bv) * dir;
        if (av instanceof Date && bv instanceof Date) return (av.getTime() - bv.getTime()) * dir;

        return String(av).localeCompare(String(bv)) * dir;
      });
    }

    this.filteredRows = rows;
    this.totalRows = rows.length;

    const maxStart = this.pageIndex * this.pageSize;
    if (maxStart >= rows.length && rows.length > 0) {
      this.pageIndex = 0;
      if (this.paginator) this.paginator.pageIndex = 0;
    }

    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;
    this.pagedRows = rows.slice(start, end);
  }

  private getSortValue(row: any, col: string): any {
    switch (col) {
      case "District Collector":
        return row?.name || "";
      case "Total land to be aquired":
        return Number(row?.land_aquire || 0);
      case "Start Date":
        return row?.start_date ? new Date(row.start_date) : new Date(0);
      case "3a status":
        return row?.["3a_status"] || "";
      case "JMS request status":
        return row?.jms_request_status || "";
      case "JMS":
        return Number(row?.jms || 0);
      case "3A":
        return Number(row?.["3A"] || 0);
      case "3C":
        return Number(row?.["3C"] || 0);
      case "3D":
        return Number(row?.["3D"] || 0);
      case "3G":
        return Number(row?.["3G"] || 0);
      case "3H":
        return Number(row?.["3H_area"] || 0);
      case "3H funds distributed":
        return Number(row?.["3H_money"] || 0);
      case "Possession":
        return Number(row?.possession || 0);
      case "Mutation":
        return Number(row?.mutation || 0);
      case "Govt. Land To Be Aquired":
        return Number(row?.govt_land_aquire || 0);
      case "Govt. Land Possession":
        return Number(row?.govt_possession || 0);
      case "Govt. Land Mutation":
        return Number(row?.govt_mutation || 0);
      case "Private Land To Be acquired":
        return Number(row?.total_private_land_aquired || 0);
      case "Total Private Land acquired":
        return Number(row?.private_land_aquired || 0);
      case "Total Private fund disbursed":
        return Number(row?.total_private_fund_deposition || 0);
      case "Funds Diposition Under PN":
        return Number(row?.private_fund_deposition || 0);
      case "Funds Distribution Under PN":
        return Number(row?.private_fund_distribution || 0);
      default:
        return "";
    }
  }

  getHeaderLabel(col: string): string {
    switch (col) {
      case "District Collector": return "District Collector";
      case "Total land to be aquired": return "Area to be acquired";
      case "Start Date": return "Start Date";
      case "3a status": return "3(a) Status";
      case "JMS request status": return "JMS Request Status";
      case "JMS": return "JMS Completed";
      case "3A": return "3(A) Completed";
      case "3C": return "3(C) Completed";
      case "3D": return "3(D) Completed";
      case "3G": return "3(G) Completed";
      case "3H": return "3(H) Completed";
      case "3H funds distributed": return "Funds Distribution Under 3(H)";
      case "Possession": return "Possession Of Land";
      case "Mutation": return "Mutation Of Land";
      case "Govt. Land To Be Aquired": return "Govt. Land To Be Acquired";
      case "Govt. Land Possession": return "Govt. Land Possession";
      case "Govt. Land Mutation": return "Govt. Land Mutation";
      case "Private Land To Be acquired": return "Total Area to be acquired by PN";
      case "Total Private Land acquired": return "Area Actually acquired under PN";
      case "Total Private fund disbursed": return "Total Private fund Diposition";
      case "Funds Diposition Under PN": return "Funds Diposition Under PN";
      case "Funds Distribution Under PN": return "Funds Distribution Under PN";
      default: return col;
    }
  }

  trackByRow(index: number, row: any) {
    return row?.id || row?.name || index;
  }

  formatNumber(value: any): string {
    const numericValue = Number(value);
    return isFinite(numericValue) ? numericValue.toFixed(2) : "0.00";
  }

  formatPercentage(completed: any, total: any): string {
    const completedValue = Number(completed);
    const totalValue = Number(total);

    if (
      !isFinite(completedValue) ||
      !isFinite(totalValue) ||
      totalValue <= 0
    ) {
      return "0.00%";
    }

    return `${((completedValue / totalValue) * 100).toFixed(2)}%`;
  }

  goToCollectorDashboard(collector) {
    this.router.navigate(["/collector", collector.id]);
  }

  downloadReport() {
    this.reportsService.getAllProjectsReport().subscribe((res) => {
      this.isDownloading = true;
      this.reportsService.checkDownloadStatus(res.id).subscribe((res) => {
        this.isDownloading = false;
        this.isDownloaded = res;
      });
    });
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.chart) {
      this.chart.destroy();
    }
  }
}
